import React, { useState, useEffect } from 'react'
import './style.scss'

import Container from './../../components/Container'
import { Button, Input, Pass, Form } from './../../components/Form'
import { mensagemErro, mensagemInfo, mensagemSucesso } from './../../components/Layout'
import ThemeSelector from './../../components/Theme/Selector'

import { useLayout } from './../../context/Layout'
import { useAuth } from './../../context/Auth'

import api from './../../api'

function Perfil() {

    const { setLoadFull } = useLayout()
    const { getUser, setUser } = useAuth()
    const user = getUser()

    const [data, setData] = useState([])
    const [imageSelected, setImageSelected] = useState('')
    const [imageAvatar, setImageAvatar] = useState('')
    const [googleLoad, setGoogleLoad] = useState(false)
    const [novaSenha, setNovaSenha] = useState('')

    useEffect(() => {

        onBuscaDados()

        const avatarName = getUser().avatar.split('/')
        setImageSelected(avatarName[4])

    }, [])

    async function onBuscaDados() {

        setLoadFull(true)

        const resp = await api.get('avatars')

        if (resp.data?.erro) {
            setLoadFull(false)
            mensagemErro(`${resp.data.erro.message}`)

            return
        }

        setData(resp.data)
        setLoadFull(false)
    }

    function onSelected(item) {

        setImageSelected(item.name)
        setImageAvatar(item.image)
    }

    async function onAtualizar(data) {

        const { senha, repeteSenha } = data

        let dataSend = {}

        if (senha?.length > 0 || repeteSenha?.length > 0) {
            if (senha !== repeteSenha) {
                mensagemInfo('As senhas devem ser iguais')
                return
            }

            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/;
            if (!passwordRegex.test(senha)) {
                mensagemInfo('A senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas, números e caracteres especiais')
                return
            }

            dataSend.pass = data.senha
        }

        if (imageAvatar)
            dataSend.avatar = imageSelected

        if (dataSend.length === 0) return

        setLoadFull(true)

        const usuario = getUser()
        const resp = await api.post('perfil/save', dataSend)

        if (resp.data?.erro) {
            setLoadFull(false)
            mensagemErro(`${resp.data.erro.message}`)

            return
        }

        usuario.avatar = imageAvatar
        setUser(usuario)

        mensagemSucesso('Perfil atualizado com sucesso!')
        setLoadFull(false)
    }

    return (
        <Container
            title='Perfil'
            titlesub='Configuração / Perfil'
        >
            <div className="settings-container">
                <Form onSubmit={onAtualizar}>
                    <div className="settings-section">
                        <div className="section-header">
                            <h3>Identidade</h3>
                            <p>Sua foto de perfil e informações pessoais.</p>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="profile-header">
                                    <div className="current-avatar">
                                        <img src={getUser().avatar} alt="Avatar Atual" />
                                    </div>
                                    <div className="profile-info">
                                        <div className="profile-email">{getUser().nome}</div>
                                        <div className="profile-role">Administrador</div>
                                    </div>
                                </div>

                                <Input disabled name='email' tituloe='E-mail' colr='col-lg-12' placeholder='email@email.com' value={getUser().email} />

                                {
                                    !user?.finished && (
                                        <div style={{ marginTop: 24 }}>
                                            <label style={{ fontSize: '14px', fontWeight: 500, color: 'var(--color-text-primary)' }}>Alterar Avatar</label>
                                            <div className="avatar-grid">
                                                {data.map((item, index) => (
                                                    <img
                                                        className={imageSelected === item.name ? 'selected' : ''}
                                                        key={index}
                                                        src={item.image}
                                                        onClick={() => onSelected(item)}
                                                        alt={`Avatar ${index}`}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>


                    {/* <div className="settings-section">
                        <div className="section-header">
                            <h3>Vincular</h3>
                            <p>Vincule sua conta para facilitar o acesso.</p>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <Button
                                    load={googleLoad}
                                    loaderColor="#757575"
                                    type="button"
                                    className="btn-google"
                                    name={user?.finished ? 'Conectado com Google' : 'Conectar com Google'}
                                    disabled={user?.finished}
                                    icon={<i className="fab fa-google"></i>}
                                    onClick={() => {
                                        if (user?.finished) return;
                                        setGoogleLoad(true)
                                    }}
                                />
                            </div>
                        </div>
                    </div> */}

                    {
                        !user?.finished && (
                            <div className="settings-section">
                                <div className="section-header">
                                    <h3>Segurança</h3>
                                    <p>Atualize sua senha de acesso.</p>
                                </div>

                                <div className="card">
                                    <div className="card-body">
                                        <div className="column" style={{ marginLeft: -12 }}>
                                            <Pass name='senha' titulo='Nova Senha' col='col-lg-8' placeholder='Digite sua senha' onChange={(e) => setNovaSenha(e.target.value)} />
                                            <div style={{ paddingLeft: 12, marginTop: 4, marginBottom: 16 }}>
                                                <div style={{ fontSize: '13px', color: novaSenha.length >= 8 ? '#28a745' : '#6c757d', display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                                    <i className={`fas fa-${novaSenha.length >= 8 ? 'check' : 'times'}`} style={{ marginRight: 8, width: 14, textAlign: 'center' }}></i> Mínimo de 8 caracteres
                                                </div>
                                                <div style={{ fontSize: '13px', color: /[A-Z]/.test(novaSenha) ? '#28a745' : '#6c757d', display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                                    <i className={`fas fa-${/[A-Z]/.test(novaSenha) ? 'check' : 'times'}`} style={{ marginRight: 8, width: 14, textAlign: 'center' }}></i> Pelo menos uma letra maiúscula
                                                </div>
                                                <div style={{ fontSize: '13px', color: /[a-z]/.test(novaSenha) ? '#28a745' : '#6c757d', display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                                    <i className={`fas fa-${/[a-z]/.test(novaSenha) ? 'check' : 'times'}`} style={{ marginRight: 8, width: 14, textAlign: 'center' }}></i> Pelo menos uma letra minúscula
                                                </div>
                                                <div style={{ fontSize: '13px', color: /\d/.test(novaSenha) ? '#28a745' : '#6c757d', display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                                    <i className={`fas fa-${/\d/.test(novaSenha) ? 'check' : 'times'}`} style={{ marginRight: 8, width: 14, textAlign: 'center' }}></i> Pelo menos um número
                                                </div>
                                                <div style={{ fontSize: '13px', color: /[^a-zA-Z\d]/.test(novaSenha) ? '#28a745' : '#6c757d', display: 'flex', alignItems: 'center' }}>
                                                    <i className={`fas fa-${/[^a-zA-Z\d]/.test(novaSenha) ? 'check' : 'times'}`} style={{ marginRight: 8, width: 14, textAlign: 'center' }}></i> Pelo menos um caractere especial
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: 16 }}></div>
                                            <Pass name='repeteSenha' titulo='Confirmar Senha' col='col-lg-8' placeholder='Confirme sua senha' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    <div className="settings-section">
                        <div className="section-header">
                            <h3>Preferências</h3>
                            <p>Personalize sua experiência no sistema.</p>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <ThemeSelector />
                            </div>
                        </div>
                    </div>

                    {!user?.finished && <div className="form-actions">
                        <Button name='Salvar Alterações' />
                    </div>}
                </Form>
            </div>
        </Container>
    )
}

export default Perfil